import React from "react";
import { useTranslation } from "react-i18next";
import { AiFillGithub } from "react-icons/ai";
import { TiWorld } from "react-icons/ti";
import blob from "../../assets/Kevin/blob.svg";
import orangeBlob from "../../assets/Kevin/blob (3).svg";
import "../Styles/cards.css";

export const ProyectCardV2 = ({ item, index }) => {
	console.log(index);
	const [t] = useTranslation("global");
	return (
		// <div className="flex justify-center items-center card bg-gray-900">
		// 	<div className="card-l p-3 ">
		// 		<p className="font-Poppins font-semibold title">{item.title}</p>
		// 		<hr
		// 			className="bg-gray-200 rounded-md mb-2"
		// 			style={{
		// 				height: "2px",
		// 			}}
		// 		/>
		// 		<p className="font-Poppins content">{t(item.content)}</p>
		// 		<div className="flex mt-1">
		// 			<AiFillGithub
		// 				className="text-3xl hover:text-yellow-400 cursor-pointer mx-2"
		// 				onClick={() => window.open(item.github)}
		// 			/>
		// 			<CgWebsite
		// 				className="text-3xl hover:text-yellow-400 cursor-pointer mx-2"
		// 				onClick={() => window.open(item.link)}
		// 			/>
		// 		</div>
		// 	</div>
		// 	<div className="card-r">
		// 		<img loading='lazy' src={item.image} alt={item.title} />
		// 	</div>
		// </div>
		<div
			className="bg-white shadow-2xl p-5 rounded-2xl m-5 justify-center flex flex-col items-center"
			style={{
				width: "270px",
			}}
		>
			<p className="font-Poppins font-bold text-gray-800 text-1xl">
				{item.title}
			</p>
			<div className="relative">
				{index % 2 === 0 ? (
					<img loading='lazy'
						src={blob}
						alt="blob-orange"
						style={{
							width: "100%",
						}}
					/>
				) : (
					<img loading='lazy'
						src={orangeBlob}
						alt="blob-orange"
						style={{
							width: "100%",
						}}
					/>
				)}
				<img loading='lazy'
					src={item.image}
					alt={item.title}
					style={{
						width: item.moreBig ? "190px" : "150px",
						position: "absolute",
						top: "50px",
						left: item.moreBig ? "20px" : "44px",
						borderRadius: "15px",
					}}
				/>
				<p className="font-Poppins font-medium text-gray-800 text-smt">{t(item.content)}</p>
				<br/>
				<div className="flex justify-center items-center">
					<AiFillGithub
						className="text-3xl hover:text-yellow-400 cursor-pointer mx-2"
						onClick={() => window.open(item.github)}
					/>
					<TiWorld
						className="text-4xl hover:text-yellow-400 cursor-pointer mx-2"
						onClick={() => window.open(item.link)}
					/>
				</div>
			</div>
		</div>
	);
};

export default ProyectCardV2;
